var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Currently-Blocked IP Addresses ")]),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              loading: _vm.pending
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "gg-btn",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.triggerModal(item.ip)
                          }
                        }
                      },
                      [_vm._v(" Delete ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("gg-modal", {
            attrs: {
              "is-active": _vm.dialog
            },
            on: {
              close: _vm.triggerModal
            },
            scopedSlots: _vm._u([
              {
                key: "toolbar",
                fn: function fn() {
                  return [_vm._v("Remove IP")]
                },
                proxy: true
              },
              {
                key: "body",
                fn: function fn() {
                  return [
                    _vm._v(
                      "Are you certain that you wish to delete the IP address “" +
                        _vm._s(_vm.ipToRemove) +
                        "”?"
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "actions",
                fn: function fn() {
                  return [
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: ""
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.triggerModal($event)
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        attrs: {
                          primary: "",
                          loading: _vm.dialogPending
                        },
                        on: {
                          click: _vm.removeIp
                        }
                      },
                      [_vm._v("Remove IP")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }